module.exports = __webpack_public_path__ + "static/media/ET-Series.67bce89e.png";